const portal = '/portal'
const host = process.env.node_backend_host
// if (!host) {
//     console.trace('无法获取环境变量：node_backend_host')
// }
const prd = {
    PortalBaseURL: host + portal,
    PortalBrowserBaseURL: portal,
    bidBrowserUrl: '//bid.jstec.com.cn',
    chatUrl: '//www.jstec.com.cn',
    baseImgUrl: '/',
    businessBrowserUrl: '/goto',
    bcsBrowserUrl: '//bcs.jstec.com.cn'
}
export default prd
